var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.presentation)?_c('span',{staticClass:"inline-flex items-center",class:_vm.presentation.color,style:(_vm.iconStyle),attrs:{"role":"img","aria-label":'Загальне враження: ' + _vm.presentation.label,"title":_vm.presentation.label}},[_c('i',{class:_vm.presentation.icon,attrs:{"aria-hidden":"true"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }